import FormBuilderModel from "../../../../common/models/tracked/formBuilderModel";
import WorkflowStep from "./workflowStep";
import Vue from "vue";
import {PermitteeType} from "~/enums/permitteeType";
import Guid from "~/helpers/guid";
import ThirdPartyCompleter from "../formElements/templates/thirdPartyCompleter";
import IRepo from "../../../../common/interfaces/repo";
import Repo from "../../../../common/state/modules/repo";
import FormElement from "../formElements/formElement";
import {userActivationStatusDisplay} from "~/deactivatable";
import PermitteeAble from '~/mixins/permitteeAble';

export default class Submitter extends PermitteeAble(FormBuilderModel) {
  reference_id: string;
  reference_type: number = PermitteeType.originalSubmitter;
  name: string;
  first_name: string;
  last_name: string;
  activation_status: number;

  static repo: IRepo<Submitter> = new Repo<Submitter>('submitters', Submitter);

  constructor(workflowStep: WorkflowStep, json?: any) {
    super();
    this.defineProperty('client_id', json?.client_id ? json['client_id'] : Guid.create());
    this.defineProperty('reference_id', json ? json['reference_id'] : null);
    this.defineProperty('reference_type', json ? json['reference_type'] : PermitteeType.originalSubmitter);
    this.setHelperFields(json);
    this.loadFromJson(json, workflowStep.rootModel);
    this.rootModel = workflowStep.rootModel;
    this.parent = workflowStep;
    Submitter.repo.add(this);
    Vue.set(workflowStep, 'submitter', this);
  }

  update(props) {
    Object.getOwnPropertyNames(props).forEach(key => {
      this[key] = props[key];
    });
  }

  get rootName(): string {
    return this.elementName;
  }

  get elementName(): string {
    return 'submitter';
  }

  get isCollectionRoot(): boolean {
    return false;
  }

  get fullName(): string {
    switch (this.reference_type) {
      case PermitteeType.group:
        return this.name;
      case PermitteeType.user:
        return `${userActivationStatusDisplay(this)}`;
      case PermitteeType.thirdParty:
        if (this.thirdPartySubmitter) {
          return this.thirdPartySubmitter.referenceNameOrDefault;
        }
        break;
      case PermitteeType.priorStep:
        const ws = this.parent.previousWorkflowStepsWithCompleter.find(step => step.id === this.reference_id);

        if (ws) {
          return `${ws.titleOrDefault} Submitter`;
        }

        return '';
      case PermitteeType.lookupField:
        return 'Lookup Field';
      default:
        return 'Original Submitter';
    }
    return null;
  }

  get thirdPartySubmitter(): ThirdPartyCompleter {
    return this.parent.referenceableThirdPartyElements.find(tp => tp.client_id === this.reference_id);
  }

  get lookupFieldSubmitter(): FormElement {
    return this.parent.referenceableLookupObjectModelFields.find(lf => lf.client_id === this.reference_id);
  }

  resetToOriginalSubmitter(): void {
    this.reference_type = PermitteeType.originalSubmitter;
    this.reference_id = '';
    this.resetHelperFields();
  }

  private get helperFields(): string[] {
    return ['first_name', 'last_name', 'name', 'reference_name', 'activation_status'];
  }

  private setHelperFields(json: any = {}) {
    for (const field in this.helperFields) {
      if (json[field]) this.defineProperty(field, json[field]);
    }
  }

  private resetHelperFields(): void {
    this.first_name = '';
    this.last_name = '';
    this.name = '';
    this.activation_status = null;
  }
}
